import { I18n } from '@calendly/i18n'
import { TitleText } from '@calendly/ui/components/typography'

import {
  sectionCss,
} from './styles'
import { TimezoneSection } from './timezone_section'

export const AdditionalSettingsSection = ({ isLocked = false }) => (
  <section className={sectionCss} data-testid="additional-settings-section">
    <TitleText level={3} size="medium">
      {I18n.t('publisher.event_type_editor_crud.availability.additional_settings_title')}
    </TitleText>
    <TimezoneSection isLocked={isLocked} />
  </section>
)
